import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '1 — ¿Cómo recibo el PROFEPACK después de comprar?',
  answer: 'Al confirmar el pago recibís un email con el link de descarga inmediata. En menos de 5 minutos tenés todo en tu dispositivo. Acceso inmediato, 24/7, sin esperas.'
}, {
  question: '2 — ¿Sirve para mi provincia o solo para Buenos Aires?',
  answer: 'Sirve para TODA Argentina. El PROFEPACK está alineado a los NAP (Núcleos de Aprendizaje Prioritarios) de Lenguas Extranjeras del Ministerio de Educación de la Nación, que aplican en todas las provincias. Cada tomo también incluye referencias a los diseños curriculares de Buenos Aires, CABA, Córdoba, Santa Fe, Mendoza y Tucumán.'
}, {
  question: '3 — ¿Es editable? ¿Puedo modificarlo?',
  answer: 'Los archivos son PDF de alta calidad, listos para imprimir o proyectar en el aula. Podés usarlos tal cual o adaptarlos con cualquier herramienta de edición de PDF. No necesitás software especial.'
}, {
  question: '4 — ¿Los 6 bonos están en todas las ofertas?',
  answer: 'Sí. Los 6 bonos estratégicos están incluidos en las 3 opciones: Primaria, Secundaria y Pack Completo. No importa cuál elegís — siempre recibís los 6 bonos sin costo extra.'
}, {
  question: '5 — ¿Puedo comprar Primaria ahora y Secundaria después?',
  answer: 'Sí. Podés empezar con el nivel que más necesitás y completar el Pack Completo después. Aunque si das clases en los dos niveles, el Pack Completo es siempre la opción más conveniente — ahorrás $7.990 versus comprar los dos por separado.'
}, {
  question: '6 — ¿Sirve si soy docente con poca experiencia?',
  answer: 'Especialmente si sos docente nuevo. El PROFEPACK te da la estructura que necesitás para entrar al aula con confianza desde el primer día. Cada clase tiene guion completo, consignas claras y tiempo estimado. No tenés que improvisar nada.'
}, {
  question: '7 — ¿Sirve para cursos difíciles o con mucho desorden?',
  answer: 'Sí. Las secuencias didácticas están diseñadas con actividades variadas, cortas y con instrucciones claras que mantienen la atención de los grupos más difíciles. El Bono 2 (30 Clases Salvavidas) es especialmente útil para estos contextos.'
}, {
  question: '8 — ¿Está actualizado al currículo vigente?',
  answer: 'Totalmente. Cada tomo está alineado a los NAP de Lenguas Extranjeras (Resolución CFE Nº 181/12 para Primaria y 180/12 para Secundaria) y a los diseños curriculares provinciales más recientes. La bibliografía oficial está incluida al final de cada tomo.'
}, {
  question: '9 — ¿Tiene garantía real?',
  answer: '100% real. Si en 7 días corridos desde la compra el material no cumple tus expectativas, te devolvemos el dinero completo sin preguntas ni formularios. Solo escribinos y listo.'
}, {
  question: '10 — ¿Qué diferencia tiene PROFEPACK con otros packs que vi?',
  answer: 'Tres diferencias que no encontrás en ningún otro lugar:\n\n1. SOLUCIONARIO COMPLETO en cada tomo — todas las respuestas correctas incluidas para que no pierdas tiempo corrigiendo.\n\n2. COBERTURA TOTAL — 12 tomos que cubren desde 1° grado de primaria hasta 6° año de secundaria. No es un recurso suelto, es un sistema completo.\n\n3. ALINEACIÓN CURRICULAR ARGENTINA — no es material traducido de otro país. Fue creado específicamente para el sistema educativo argentino, con NAP, efemérides y contexto local.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-74">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 mb-10" data-id="element-75">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#FF6B00] bg-[#0d0800]' : 'border-[#FF6B00]/20 bg-black'}`} data-id="element-76">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-77">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-78">
                  ❓ {faq.question}
                </span>
                <span className={`text-[#FF6B00] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-79">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-80">
                  <div className="h-px bg-[#FF6B00]/20 mb-4" data-id="element-81" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-82">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}